import { Component, OnInit, viewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { MatInput } from '@angular/material/input';
import { map, shareReplay, startWith, withLatestFrom } from 'rxjs/operators';
import { MatFormField, MatLabel, MatHint } from '@angular/material/form-field';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';
import { LetDirective } from '@ngrx/component';

import { MatOption } from '@angular/material/core';

@Component({
    selector: 'sphere-autocomplete-formly',
    template: `
        <mat-form-field appearance="fill">
            <mat-label>{{ props.label }}</mat-label>
            <input matInput [matAutocomplete]="auto" [formControl]="formControl" [formlyAttributes]="field" />
            <mat-autocomplete #auto="matAutocomplete">
                <ng-container *ngrxLet="options$; let options; let optionsError = $error; let optionsComplete = $complete">
                    <ng-container *ngrxLet="filteredOptions$; let filteredOptions; let e = $error; let c = $complete">
                        @for (option of filteredOptions; track option) {
                            <mat-option [value]="option">
                                {{ option }}
                            </mat-option>
                        }
                        @if (optionsError) {
                            <mat-option [disabled]="true">Error loading</mat-option>
                        }
                    </ng-container>
                </ng-container>
            </mat-autocomplete>
            @if (!!props.description) {
                <mat-hint>{{ props.description }}</mat-hint>
            }
        </mat-form-field>
    `,
    styles: [``],
    imports: [
        MatFormField,
        MatLabel,
        MatInput,
        MatAutocompleteTrigger,
        ReactiveFormsModule,
        FormlyModule,
        MatAutocomplete,
        LetDirective,
        MatOption,
        MatHint
    ]
})
export class AutocompleteFormlyComponent extends FieldType implements OnInit {
    readonly formFieldControl = viewChild<MatInput>(MatInput);

    public options$: Observable<any[]>;
    public filteredOptions$: Observable<any[]>;

    ngOnInit() {
        this.options$ = this.props.filterOptions.pipe(shareReplay(1));
        this.filteredOptions$ = this.formControl.valueChanges.pipe(
            startWith(''),
            withLatestFrom(this.options$),
            map(([value, options]) => this.props.filter(options, value) as any[])
        );
    }
}
